// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#settingsApp ul[data-v-2e1ff7fa]{background-color:#fff;width:100%;position:fixed;margin-top:0;z-index:499;border-top:1px solid #dfdfdf;border-bottom:1px solid #dfdfdf}#settingsApp ul li[data-v-2e1ff7fa]{cursor:pointer}#settingsApp ul li a[data-v-2e1ff7fa]{color:#6c868e!important}#settingsApp ul li a.active[data-v-2e1ff7fa]{color:#363a41!important}#settingsApp ul li a[data-v-2e1ff7fa]:hover{color:#25b9d7!important}", ""]);
// Exports
module.exports = exports;
